import React from "react";
import "containers/Account/Info/Account.css";
import "containers/Account/MyChildren/MyChildren.css";
import { Container } from "@material-ui/core";
import CustomInput from "components/General/Form/CustomInput";
import CustomSelect from "components/General/Form/CustomSelect";
class GuardianForm extends React.Component {

  render() {
    return (
      <div style={{ display: "block" }}>

        <Container>
          <form id="child-form" onSubmit={this.props.onSaveClicked.bind(this)} className="account-form">
            <div className="form-wrapper">

              <CustomInput
                orientation="labeled"
                name="name"
                placeholder="Name"
                label="Name:"
                value={this.props.name}
                handleChange={this.props.onDataChange.bind(this)}
                error={this.props.errorMap.has("nameError") ? (this.props.errorMap.get("nameError")):("")}
                required
              />

              <CustomInput
                  orientation="labeled"
                  name="email"
                  placeholder="Email"
                  label="Email:"
                  value={this.props.email}
                  handleChange={this.props.onDataChange.bind(this)}
                  error={this.props.errorMap.has("emailError") ? (this.props.errorMap.get("emailError")):("")}
                  required
                />

                <CustomSelect
                  orientation="labeled"
                  name="relationship"
                  title="Relationship: "
                  placeholder="Select Relationship"
                  value={this.props.relationship}
                  handleChange={this.props.onDataChange.bind(this)}
                  error={this.props.errorMap.has("relationshipError") ? (this.props.errorMap.get("relationshipError")):("")}
                  options={[
                    "Parent",
                  ]}
                  required
                />
                <br/>
            </div>
          </form>
        </Container>
      </div>
    );
  }
}

export default GuardianForm;




